/**
 * GuidedTourBox — displays a styled box on the Schedule A Tour page that
 * renders the Knock custom tour-column embed (an HTML string) between the
 * PageBlurb and ScheduleATour sections.
 *
 * The token is type 'text' bound to the custom_knock_tour_column property
 * field, which may contain arbitrary HTML (iframes, script tags, etc.).
 * We render the raw value via dangerouslySetInnerHTML so the embed executes
 * properly — RichTextContent would sanitise and strip those tags.
 */

import type { ComponentContentSchema } from '@vibesites/runtime';
import { useContentToken, EditableToken } from '@vibesites/runtime/react';

export function GuidedTourBox() {
  const knockButton = useContentToken('guidedtourbox.knock_button');

  return (
    <section className="bg-muted py-lg">
      <div className="mx-auto max-w-3xl px-md text-center">
        <h2 className="font-heading text-2xl text-foreground mb-md">
          Schedule a Guided Tour
        </h2>
        <div className="bg-card rounded-lg shadow-md p-lg flex items-center justify-center">
          <EditableToken
            path="guidedtourbox.knock_button"
            type="text"
            label="Knock Tour Button"
            as="div"
            className="guided-tour-knock-button"
          >
            <div dangerouslySetInnerHTML={{ __html: knockButton ?? '' }} />
          </EditableToken>
        </div>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'GuidedTourBox',
  displayName: 'Guided Tour Box',
  tokens: {
    'guidedtourbox.knock_button': {
      label: 'Knock Tour Button',
      type: 'text',
      defaultField: 'custom_knock_tour_column',
      defaultValue: '',
    },
  },
};

(GuidedTourBox as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default GuidedTourBox;
